// extracted by mini-css-extract-plugin
export default {"loadingIndicator":"xC2TYsbApemPhq6H5iOg-LandingPagesWrapper-loadingIndicator"};